import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    container: {display: "flex", alignItems: "top", minHeight: 55},
    unit: {display: "flex", alignItems: "center", minHeight: 55, paddingLeft: '0.5rem'}
}));

export default useStyles;